import * as yup from 'yup'
import { extractValidationErrors } from './errors'
import toastMessage from 'components/utils/toasts'

export const isNumeric = (value: string) => {
	return !isNaN(Number(value))
}

export const validatePhone = (value: string) => {
	return !!value && isNumeric(value) && value.length === 7
}

const defaultErrorMessage = 'Eitthvað fór úrskeiðis, vinsamlegast reyndu aftur síðar'

export const validateSchema = async (schema: yup.ObjectSchema<any>, data: any) => {
	try {
		await schema.validate(data, { abortEarly: false })
		return null
	} catch (error) {
		if (error instanceof yup.ValidationError) {
			const errors = extractValidationErrors(error)
			toastMessage({
				type: 'error',
				message: Object.values(errors).join('\n'),
			})
			return errors
		}
		console.error(error)
		toastMessage({
			type: 'error',
			message: defaultErrorMessage,
		})
		return {
			error: defaultErrorMessage,
		}
	}
}
